import { Box, Grid, Typography, useTheme } from "@mui/material";
import FareharbourIcon from "assets/icons/fareharbor_icon.svg";
import OpenTableIcon from "assets/icons/opentable.svg";
import ResyIcon from "assets/icons/resy_icon.svg";
import SevenRoomIcon from "assets/icons/seven_room.svg";
import ZenotiIcon from "assets/icons/zenoti.svg";
import { useNavigate } from "react-router-dom";
import { integrationStyles } from "styles/IntegrationDirectory/integration.styles";

type cardData = {
  title: string;
  icon: string;
  link?: string;
};

const integrationsData: cardData[] = [
  {
    title: "FareHarbor",
    icon: FareharbourIcon,
    link: "/settings/integration/fareharbor",
  },
  {
    title: "Resy",
    icon: ResyIcon,
  },
  {
    title: "SevenRooms",
    icon: SevenRoomIcon,
  },
  {
    title: "OpenTable",
    icon: OpenTableIcon,
  },
  {
    title: "Zenoti",
    icon: ZenotiIcon,
  },
];

const Integrations = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Box margin="1rem" fontFamily={theme.typography.fontFamily}>
      {/* Top Bar */}
      <Box marginBottom={2}>
        <Typography sx={integrationStyles.mainHeading}>Platforms</Typography>

        <Typography sx={integrationStyles.subHeading}>
          Select your booking system to connect your Calendar
        </Typography>
      </Box>

      <Grid container spacing={2} justifyContent="center" alignItems="center">
        {integrationsData.map((data, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Box
              sx={integrationStyles.integrationCard(theme)}
              onClick={() => (data.link ? navigate(data.link) : null)}
            >
              <img src={data.icon} alt={data.title} width={50} height={50} />
              <Typography sx={integrationStyles.cardTitle}>
                {data.title}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Integrations;
